export class Operator {
  name: string;
  value: string;
}

export const OPERATORS: Operator[] = [
  { name: 'is equal to', value: '=='}, 
  { name: 'is not equal to', value: '!=' },
];
